import { get } from './storage'
import { ReactNode } from 'react'

export type Role = 'Admin'|'Dispatcher'|'Loader'|'Trucker'|'Accountant'
export function useRole(): Role { return get<Role>('role','Admin') }

export function Can({roles, children}:{roles:Role[]; children:ReactNode}){
  const role = useRole()
  if (!roles.includes(role)) return null
  return <>{children}</>
}
